import { pick } from 'lodash'
import { track } from '../analytics'

export const personasContactAboutTrial = args => {
  track(
    'Personas Contact About Trial',
    pick(args, ['workspaceId', 'workspaceSlug', 'email'])
  )
}
